import(/* webpackMode: "eager" */ "/app/app/editor/page.tsx");
